/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TransactionType {
    DEPOSIT = 'Deposit',
    WITHDRAWAL = 'Withdrawal',
    FEE = 'Fee',
    RECEIVE = 'Receive',
    SEND = 'Send',
    BONUS = 'Bonus',
    TRANSFER = 'Transfer',
}
